import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {Link, useNavigate} from 'react-router-dom'
import { list } from '../../features/dashboard/DocumentAgentRequestSlice';
import Loading from '../../Loading';
import Header from './Header';
import Input from '../form/Input';
import { Calendar } from "react-multi-date-picker";
import DatePicker,{DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import * as moment from 'jalali-moment';

function DocumentAgentRequest () {
    // $data = SectionOne::orderByRaw('RAND()')->get();
    // $data = SectionOne::inRandomOrder()->get();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')
    let archiveSectionOneLoading = true
    
    const date = new DateObject({ calendar: persian, locale: persian_fa })
    let { 
        agentRequestList, 
        locading, 
        success,
        message,
        error,
    } = useSelector(state => state.documentAgentRequestSlice)
    const [edit, setEdit] = useState()
    const [title, setTitle] = useState()
    const [name, setName] = useState()
    const [flag, setFlag] = useState()
    let [modalShow, setModalShow] = useState(false)
    const editHandler = (id, name, plag) => { 
        setEdit(id)
        setName(name)
        setFlag(plag)
        setModalShow(true)
        message = ''
        
    }
    const updateHandler = (event) => {
        // console.log(event)
    }
    
    const closeButtonHandler = () => {
        message = ''
        setModalShow(false)
    }
    useEffect(() => {
        // dispatch(sectionIndex(token))
        if(modalShow === false) {
            message = ''
        }
    },[success])

    return (
        <>
        { archiveSectionOneLoading === true ? (<Loading />) : null }
        <div className='row g-2 p-5 my-5'>
            <Header title={'درخواست نمایندگان'} />
            <table className="table table-hover" style={{direction: 'rtl'}}>
                <thead className="table-light">
                    <tr>
                    <th scope="col" className='text-center'>#</th>
                    <th scope="col">نام</th>
                    <th scope="col">نام خانوادگی</th>
                    <th scope="col" className='text-center'>تاریخ ایجاد</th>                
                    <th scope="col" className='text-center'>تاریخ بروز رسانی</th>
                    <th scope="col" className='text-center'>بروز رسانی</th>
                    </tr>
                </thead>
                <tbody className="table-group-divider">
                    {
                        agentRequestList.map((item,key) => (
                            <tr id={item.id}>
                                <th className='text-center'>{++key}</th> 
                                <td>{item.name}</td>    
                                <td>{item.family}</td>          
                                <td className='text-center'>
                                    {moment(item.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}
                                </td>
                                <td className='text-center'>
                                    {moment(item.updated_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}
                                </td>
                                <td className='text-center'>
                                    <a onClick={(event) => editHandler(event.target.id,item.name, item.flag)} >
                                        <i className="fa-regular fa-pen-to-square fa-fw" id={item.id}></i>
                                    </a>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <div className='col-12 text-center'>
                <button className='btn btn-outline-dark px-0'>نمایش بیشتر</button>
            </div>
        </div>
        </>
    )
}

export default DocumentAgentRequest;